import Num, { inputFormatter } from '@flipster/utils/num';

// fromAmount = toAmount / exchangeRate 내림
export const calcFromAmount = (toAmount: string, exchangeRate: string, precision: number, maxLength: number) =>
  subStringWithMaxLength(Num(toAmount).dividedBy(exchangeRate).toFixed(precision).toString(), precision, maxLength);

// toAmount = fromAmount * exchangeRate 내림
export const calcToAmount = (fromAmount: string, exchangeRate: string, precision: number, maxLength: number) =>
  subStringWithMaxLength(
    Num(fromAmount).multipliedBy(exchangeRate).toFixed(precision).toString(),
    precision,
    maxLength,
  );

// amountRatio = convertibleBalance / 100 * ratio
export const calcAmountRatio = (convertibleBalance: string, ratio: string, precision: number, maxLength: number) =>
  subStringWithMaxLength(
    Num(convertibleBalance).dividedBy(100).multipliedBy(ratio).toFixed(precision).toString(),
    precision,
    maxLength,
  );

// When calculate max length, must be included comma. after calculating, should remove comma
export const subStringWithMaxLength = (value: string, precision: number, maxLength: number) => {
  return inputFormatter(value, { precision, withComma: true, maxLength }).replace(/,/g, '');
};
